import * as Yup from "yup";

export const table = {
  primaryData: [
    {
      title: "Name",
      value: "global_name",
      type: "configue",
    },
    {
      title: "status",
      value: "status",
    },
    {
      title: "CreatedBy",
      value: "created_by_name",
      type: "configue",
    },
    {
      title: "CreatedAt",
      value: "created_at",
      type: "configue",
    },
    {
      title: "Actions",
      width: "5%",
      sendStatus: true,
    },
  ],
  secondaryData: [],
};

export type chapter = {
  global_name: string;
  gcf_public_chapter_id: string;
  color_icon_url: string;
  patch_icon_url: string;
  status: string;
  chapter_code: string;
  image_url: string;
  gcf_learn_chapter_id: string;
  gcf_learn_chapter_name: string;
  gcf_public_chapter_name: string;
  npractice_public_chapter_id: string;
  npractice_public_chapter_name: string;
  npractice_practice_chapter_id: string;
  npractice_practice_chapter_name: string;
};

export const chapterInitialValues: chapter = {
  global_name: "",
  gcf_public_chapter_id: "",
  color_icon_url: "",
  patch_icon_url: "",
  status: "ACTIVE",
  chapter_code: "",
  image_url: "",
  gcf_learn_chapter_id: "",
  gcf_learn_chapter_name: "",
  gcf_public_chapter_name: "",
  npractice_public_chapter_id: "",
  npractice_public_chapter_name: "",
  npractice_practice_chapter_id: "",
  npractice_practice_chapter_name: "",
};

export const chapterMandatoryFields = [{ id: "global_name" }];

export const chapterValidationSchema = Yup.object().shape({
  global_name: Yup.string().required("Name is required"),
});

export const chapterProperties = [
  {
    id: "global_name",
    type: "text",
    label: `Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
    {
    id: "color_icon_url",
    type: "url-file-upload",
    label: `Color Icon Url`,
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
    size: 10,
    feature: "global-content-hierarchy",
    fileType: [".jpg", ".png"],
    acceptTypes: "image/*",
  },
    {
    id: "patch_icon_url",
    type: "url-file-upload",
    label: `Patch Icon Url`,
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
    size: 10,
    feature: "global-content-hierarchy",
    fileType: [".jpg", ".png"],
    acceptTypes: "image/*",
  },
  {
    id: "chapter_code",
    type: "text",
    label: `Chapter Code`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "image_url",
    type: "url-file-upload",
    label: "Image Url",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
    size: 10,
    feature: "global-content-hierarchy",
    fileType: [".jpg", ".png"],
    acceptTypes: "image/*",
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    hideNone: true,
  },
];

export const chapterPropertiesUpdate = [
  {
    id: "global_name",
    type: "text",
    label: `Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "color_icon_url",
    type: "text",
    label: `Color Icon Url`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "patch_icon_url",
    type: "text",
    label: `Patch Icon Url`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "chapter_code",
    type: "text",
    label: `Chapter Code`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "image_url",
    type: "url-file-upload",
    label: "Image Url",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
    size: 10,
    feature: "global-content-hierarchy",
    fileType: [".jpg", ".png"],
    acceptTypes: "image/*",
  },
    {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    hideNone: true,
  },
    {
    id: "gcf_public_chapter_id",
    type: "text",
    label: `Gcf Public chapter id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "gcf_public_chapter_name",
    type: "text",
    label: `Gcf Public Chapter Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "gcf_learn_chapter_id",
    type: "text",
    label: `Gcf Learn Chapter Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "gcf_learn_chapter_name",
    type: "text",
    label: `gcf Learn Chapter Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_public_chapter_id",
    type: "text",
    label: `nPractice Public Chapter Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_public_chapter_name",
    type: "text",
    label: `nPractice Public Chapter Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_practice_chapter_id",
    type: "text",
    label: `nPractice Practice Chapter Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_practice_chapter_name",
    type: "text",
    label: `nPractice Practice Chapter Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];
